import service from '@/api/service'
import { decrypt, encrypt } from '@/utils/AES'

export function customPaymentRequestConfig(authScope = 'pc') {
    const token = localStorage.getItem(authScope === 'phone' ? 'accessKeyPhone' : 'accessKey')
    if (!token || token === 'undefined' || token === 'null') {
        const error = new Error('请先登录后支付定制费用')
        error.status = 401
        error.authScope = authScope
        throw error
    }
    return { customPayment: true, authScope, headers: { Authorization: `Bearer ${token}` } }
}

async function customPaymentRequest(config) {
    const response = await service({ ...config, customPayment: true })
    return response.data
}

export async function getCustomPaymentUserInfo() {
    const value = await customPaymentRequest({
        url: '/member/sso/member/memberInfo', method: 'post', ...customPaymentRequestConfig()
    })
    let profile
    try {
        profile = typeof value === 'string' ? JSON.parse(decrypt(value)) : value
    } catch (error) {
        throw new Error('获取付款账号信息失败，请重新登录')
    }
    if (!profile || !profile.id) {
        throw new Error('获取付款账号信息失败，请重新登录')
    }
    const cachedProfile = typeof value === 'string' ? value : encrypt(JSON.stringify(profile))
    localStorage.setItem('customPaymentUserInfo', cachedProfile)
    if (!localStorage.getItem('accessKeyPhone')) {
        localStorage.setItem('userInfo', cachedProfile)
    }
    return profile
}

// userInfo 为两端共享缓存，不能用来确认手机端当前登录的账号。
export async function getCustomPaymentPhoneUserInfo() {
    const token = localStorage.getItem('accessKeyPhone')
    if (!token) return null
    const value = await customPaymentRequest({
        url: '/api/sso/member/memberInfo', method: 'post', ...customPaymentRequestConfig('phone')
    })
    let profile
    try {
        profile = typeof value === 'string' ? JSON.parse(decrypt(value)) : value
    } catch (error) { /* 失效资料需要重新验证 */ }
    if (!profile || !profile.id || !profile.phone) {
        const error = new Error('手机端登录信息已失效，请重新登录')
        error.status = 401
        error.authScope = 'phone'
        localStorage.removeItem('accessKeyPhone')
        throw error
    }
    return profile
}

// 使用手机端现有登录创建定制费订单；BXZPC 订单号沿用已有免标币支付回调。
export async function createPhoneCustomOrder(value) {
    const amount = String(value.payAmount).trim()
    if (!/^\d{1,6}$/.test(amount) || Number(amount) < 1 || Number(amount) > 100000) {
        throw new Error('请输入 1～100000 元的整数金额')
    }
    if (!/^BXZPC[a-zA-Z0-9]{1,27}$/.test(value.serialNumber)) {
        throw new Error('订单信息无效，请重新发起支付')
    }
    const orderId = await customPaymentRequest({
        url: '/api/order/createOrder', method: 'post', ...customPaymentRequestConfig('phone'),
        data: {
            type: 3, note: '定制标书费用', status: 2,
            payType: Number(value.payType) === 2 ? 2 : 1,
            payAmount: String(Number(amount)), serialNumber: value.serialNumber,
            promoteId: value.promoteId || null, payUrl: value.payUrl || '', code: value.code
        }
    })
    if (!orderId || typeof orderId === 'object') {
        throw new Error('创建付款订单失败，请稍后重试')
    }
    return orderId
}
